import { FC } from 'react';

import { Menu, MenuItem } from '@mui/material';
import { Trash2, Edit3, Copy } from 'react-feather';

interface SlideActionMenuProps {
  onClickRename: () => void;
  onClickClone: () => void;
  onClickRemove: () => void;
  onClose: () => void;
  open: boolean;
  anchorEl: HTMLElement | null;
}

export const SlideActionMenu: FC<SlideActionMenuProps> = ({
  onClickRename,
  onClickClone,
  onClickRemove,
  onClose,
  open,
  anchorEl,
}) => {
  return (
    <Menu id="slide-actions" anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem onClick={onClickRename}>
        <Edit3 size={16} style={{ marginRight: 10 }} />
        Rename Slide
      </MenuItem>
      <MenuItem onClick={onClickClone}>
        <Copy size={16} style={{ marginRight: 10 }} />
        Clone Slide
      </MenuItem>
      <MenuItem onClick={onClickRemove}>
        <Trash2 size={16} style={{ marginRight: 10 }} />
        Remove Slide
      </MenuItem>
    </Menu>
  );
};
